import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import loadable from '@loadable/component';
import classNames from 'classnames';

import { Link, LinkVariant } from '@jsmdg/yoshi';
import { useProduct } from '../../hooks/useProduct';
import styles from './StrikePriceInfo.module.scss';

const LoadableStrikePriceModal = loadable(async () => import('./StrikePriceModal'));

type Props = {
    readonly numTickets: number;
};

const StrikePriceInfo = ({ numTickets }: Props): JSX.Element | null => {
    const [showStrikePriceModal, setShowStrikePriceModal] = useState(false);
    const { originalPrice } = useProduct();

    if (!originalPrice) {
        return null;
    }

    return (
        <>
            <div
                className={classNames(
                    styles.strikePriceInfo,
                    'px-0 px-sm-6x py-0 pt-3x pt-sm-3x pb-sm-3x',
                )}
            >
                <FormattedMessage
                    defaultMessage="* Der Rabatt ist nicht auf andere Erlebnisse bei der Einlösung übertragbar. {moreInfo}"
                    values={{
                        moreInfo: (
                            <Link
                                onClick={() => setShowStrikePriceModal(true)}
                                variant={LinkVariant.Brand}
                            >
                                <FormattedMessage defaultMessage="Details" />
                            </Link>
                        ),
                    }}
                />
            </div>
            {showStrikePriceModal && (
                <LoadableStrikePriceModal
                    isOpen={showStrikePriceModal}
                    handleOnClose={() => setShowStrikePriceModal(false)}
                    numTickets={numTickets}
                />
            )}
        </>
    );
};

export { StrikePriceInfo };
